import { httpClient } from '../config';

export const clearAccountData = async (payload) => {
    try {
        const { json } = await await httpClient('/analytics/manage_raw_data/clean_account_data', {
            method: 'POST',
            body: JSON.stringify({
                settingsId: payload.id,
                accountId: payload.account_id,
                accountName: payload.account_name,
                platform: payload.platform,
                industry_id: payload.industry_id,
            }),
        })
        return json;
    } catch (error) {
        console.error('Failed to fetch goals data:', error);
        throw error;
    }
};